import React from 'react';
import moment from 'moment';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Space } from 'antd';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import * as S from '@/components/Settings/DataExtraction/styles';

export function DetailedData() {
	const { gutterLayout, dataExtractionReport } = useDataExtractionReport();

	function handleFormateDate(date?: string): string {
		return date ? moment(date).format('DD/MM/YYYY') : '-';
	}

	return (
		<Row gutter={[gutterLayout, 24]}>
			<Col xs={24} sm={12} md={12} lg={12} xl={6}>
				<Row gutter={[0, 16]}>
					<Col span={24}>
						<S.LabelLargeSemibold>{I18n.get('Company')}: </S.LabelLargeSemibold>
						<S.LabelLargeRegular>{dataExtractionReport?.organization_name}</S.LabelLargeRegular>
					</Col>
					<Col span={24}>
						<S.LabelLargeSemibold>{I18n.get('Industrial Site')}: </S.LabelLargeSemibold>
						<S.LabelLargeRegular>{dataExtractionReport?.company_name}</S.LabelLargeRegular>
					</Col>
				</Row>
			</Col>
			<Col xs={24} sm={12} md={12} lg={12} xl={6}>
				<Row gutter={[0, 16]}>
					<Col span={24}>
						<S.LabelLargeSemibold>{I18n.get('Sector')}: </S.LabelLargeSemibold>
						<S.LabelLargeRegular>{dataExtractionReport?.sector_name ?? '-'}</S.LabelLargeRegular>
					</Col>
					<Col>
						<S.LabelLargeSemibold>{I18n.get('Line')}: </S.LabelLargeSemibold>
						<S.LabelLargeRegular>{dataExtractionReport?.line_name ?? '-'}</S.LabelLargeRegular>
					</Col>
				</Row>
			</Col>
			<Col xs={24} sm={12} md={12} lg={12} xl={6}>
				<Row gutter={[0, 16]}>
					<Col span={24}>
						<S.LabelLargeSemibold>{I18n.get('Workstation')}: </S.LabelLargeSemibold>
						<S.LabelLargeRegular>{dataExtractionReport?.workstation_name ?? '-'}</S.LabelLargeRegular>
					</Col>
					<Col span={24}>
						<S.LabelLargeSemibold>{I18n.get('Name')}: </S.LabelLargeSemibold>
						<S.LabelLargeRegular>{dataExtractionReport?.extraction_name}</S.LabelLargeRegular>
					</Col>
				</Row>
			</Col>
			<Col xs={24} sm={12} md={12} lg={12} xl={6}>
				<Space direction="vertical" size={16}>
					<Col span={24}>
						<S.LabelLargeSemibold>{I18n.get('Initial reference date')}: </S.LabelLargeSemibold>
						<S.LabelLargeRegular>{handleFormateDate(dataExtractionReport?.start_date)}</S.LabelLargeRegular>
					</Col>

					<Col span={24}>
						<S.LabelLargeSemibold>{I18n.get('Final reference date')}: </S.LabelLargeSemibold>
						<S.LabelLargeRegular>{handleFormateDate(dataExtractionReport?.end_date)}</S.LabelLargeRegular>
					</Col>
				</Space>
			</Col>
		</Row>
	);
}
